module.exports = __webpack_public_path__ + "img/40_38_027_420.8766b1b2.jpg";